<template>
    <div class="bannerNode flexColumn">
        <div class="flex">
            <top-tab
                :immediately="false"
                :topBarDatas="topBarDatas"
            ></top-tab>
            <top-tab
                :topBarDatas="rightTopBarDatas"
            ></top-tab>
        </div>
        <box-border
            title="现金流预测"
        >
            <span class="PAVstyle">
                ( 万美元 ) 现金流入: {{ cost.showDatas.s1 }}, 现金流出: {{ cost.showDatas.s2 }}, 现金净流量: {{ cost.showDatas.s3 }}, 累计净流量: {{ cost.showDatas.s4 }}
            </span>
            <echart-module
                ref="cost"
                :option="cost"
            ></echart-module>
        </box-border>
    </div>
</template>
<script>
    import { mapActions } from 'vuex';
    export default {
        name: 'CostOne',
        data(){
            return {
                firstFn: true,
                yearType: '全部',
                cost: {
                    showDatas: {
                        s1: '',
                        s2: '',
                        s3: '',
                        s4: ''
                    },
                    grid: {
                        top: '10%',
                        bottom: this.fontSizeFn(55),
                        right: '2%',
                    },
                    legend: {
                        top: '0%',
                        selected: {
                            '营业现金比率': false
                        }
                    },
                    color: [1, 0, 3, 3],
                    yAxis: [
                        {
                            type: 'value',
                            alignTicks: true
                        },
                        {
                            type: 'value',
                            axisLabel: {
                                formatter: '{value} %'
                            }
                        }
                    ],
                    tooltip: {
                        formatter: (datas) => {
                            this.cost.nowClickDatas = datas;
                            this.cost.nowClickName = datas[0].axisValue;
                            let html = `${datas[0].axisValue} <br />`;
                            datas.forEach((item, index) => {
                                if(typeof item.value === 'number'){
                                    if(item.seriesName === '营业现金比率'){
                                        html += (item.marker + item.seriesName + '&nbsp;&nbsp;' + (item.value == 0 ? '0' : item.value.toFixed(2)) + '%<br/>')
                                    }else{
                                        html += (item.marker + item.seriesName + '&nbsp;&nbsp;' + item.value + '<br/>')
                                    }
                                }
                                if(index == datas.length - 1){
                                    item.data.s6.replaceAll(/\s/g, '') && (html += `<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:#FFFFFF;"></span>累计流入&nbsp;&nbsp;${item.data.s6}<br/>`)
                                    item.data.s7.replaceAll(/\s/g, '') && (html += `<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:#FFFFFF;"></span>累计流出&nbsp;&nbsp;${item.data.s7}<br/>`)
                                }
                            })
                            return html;
                        }
                    },
                    dataZoom: [
                        {
                            height: this.fontSizeFn(20),
                            moveHandleSize: 0,
                            bottom: 25,
                            textStyle: {
                                color: '#8392A5'
                            },
                            dataBackground: {
                            areaStyle: {
                                color: '#8392A5'
                            },
                            lineStyle: {
                                opacity: 0.8,
                                color: '#8392A5'
                            }
                            },
                            brushSelect: true
                        }, {
                            type: 'inside',
                            filterMode: 'filter'
                        }
                    ]
                },
                topBarDatas: [
                    {
                        name: 'Overall',
                        fn: () => {
                            this.stype = 'Project';
                            this.renderFn();
                        }
                    },
                    {
                        name: 'IU',
                        fn: () => {
                            this.stype = 'IU';
                            this.renderFn();
                        }
                    },
                    {
                        name: 'OOU',
                        fn: () => {
                            this.stype = 'OOU';
                            this.renderFn();
                        }
                    }
                ],
                rightTopBarDatas: [
                    {
                        name: '全部',
                        fn: () => {
                            this.yearType = '全部';
                            this.renderFn();
                        }
                    },
                ],
                stype: 'Project',
                otherSettings: null
            }
        },
        mounted(){
            this.$refs.cost.myChart.getZr().on('click', async (params) => {
                const xHeight = this.$refs.cost.myChart.convertToPixel({ yAxisIndex: 0 }, 0);
                const pointInPixel = [params.offsetX, params.offsetY];
                if(this.$refs.cost.myChart.containPixel('grid', pointInPixel)){
                    let seriesName;
                    if(params.event.zrY > xHeight){
                        //负轴
                        seriesName = '现金流出';
                    }else{
                        //正轴
                        seriesName = '现金流入';
                    }
                    this.cost.showDatas = {
                        s1: this.cost.nowClickDatas[0].value,
                        s2: this.cost.nowClickDatas[1].value,
                        s3: this.cost.nowClickDatas[2].value,
                        s4: this.cost.nowClickDatas[3].value
                    };
                    const data = await this.getTableData('2c9280887ca08d28017ca193e6f30003', `${this.stype}_${this.cost.nowClickName}_${seriesName}`);
                    this.OPEN_TABLEBOX_DATAS(data);
                }
            })
        },
        methods: {
            ...mapActions(['OPEN_TABLEBOX_DATAS']),
            async renderFn(){
                this.getNewVTos(
                    {
                        id: '8acba68d830e1bb901831da63ea60059',
                        stype: `${this.stype}_${this.yearType}`
                    },
                    [
                        ['现金流入', '现金流出', '现金净流量', '累计净流量', '营业现金比率'],
                        ['bar', 'bar', 'bar', 'line', 'line'],
                    ],
                    this.$refs.cost.myChart,
                    {
                        name: 'cost',
                        stackArr: ['a', 'a', 'b'],
                        hasMoreData: ['s6', 's7'],
                        moreSetting: [
                            {},
                            {},
                            {},
                            {},
                            {
                                yAxisIndex: 1,
                            }
                        ]
                    },
                    (res) => {
                        const index = res['s8'][0]
                        this.cost.showDatas = {
                            s1: res['s1'][index],
                            s2: res['s2'][index],
                            s3: res['s3'][index],
                            s4: res['s4'][index]
                        };
                        if(this.firstFn && this.yearType === '全部'){
                            this.firstFn = false;
                            this.$nextTick(() => {
                                const yearArr = res['x'].map(item => {
                                    return Number(item?.split('.')[0]);
                                });
                                const maxYear = Math.max(...yearArr);
                                const minYear = Math.min(...yearArr);
                                for(let i = minYear; i <= maxYear; i++){
                                    this.rightTopBarDatas.push({
                                        name: i + '',
                                        fn: () => {
                                            this.yearType = i + '';
                                            this.renderFn();
                                        }
                                    })
                                }
                            });
                        }
                    }
                )
            }
        },
    }
</script>
<style lang="less" scoped>
    .banner{
        padding-top: 0.2rem;
    }
</style>